import React from "react";
import { Tooltip as ATooltip } from "antd";

export default function Tooltip({ ...props }) {
  return <ATooltip {...props} />;
}
